import { render, staticRenderFns } from "./AllianceForm.vue?vue&type=template&id=76ca0af6"
import script from "./AllianceForm.vue?vue&type=script&lang=js"
export * from "./AllianceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports